// ----------------------------------------------------------------------------
// Component: Press Quotes
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, EffectFade, Autoplay } from 'swiper';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import './_press-quotes.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------
function handlePressQuoteSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index, array) {
        slide.addEventListener('focus', function(e) {
            var slidePos = swiperEl.$el[0].getBoundingClientRect();

            // Remove standard scrolling to element in focus due to it going off the screen (slides left when it needs to stay on screen)
            swiperEl.$el[0].scrollLeft = 0;
            swiperEl.slideTo(index);

            // Emulating normal tab focus due to needing to remove standard scroll
            // If element is already in viewport, do nothing
            // Otherwise, scroll to the element and it should be in the middle of the screen when scrolling stops
            if (!(slidePos.top >=0 &&
            slidePos.left >=0 &&
            slidePos.bottom <= $(window).height() &&
            slidePos.right <= $(window).width())) {
                window.scrollTo({
                    top: (slidePos.top + window.scrollY) - ($(window).height() / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            }

        })
    });
}




$(function() {
    $(".carousel--press-quotes").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("press-quotes-instance-" + index);

        // Generate unique btn classes for swiper pagination
        $this.parents('.carousel-section--press-quotes').find(".swiper-pagination").addClass("press-quotes-swiper-pagination-" + index);

        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".press-quotes-instance-" + index, {
             // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, EffectFade, Autoplay],
            slidesPerView: 1,
            spaceBetween: 15,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,
            autoplay: {
                delay: 5000,
            },
            speed: 500,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: ".press-quotes-swiper-pagination-" + index,
                type: 'bullets',
                clickable: true,
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 1024pxpx
                1024: {
                    spaceBetween: 0
                }
            },
        });

        if (swiper.slides) {
            handlePressQuoteSlides(swiper);
        } else {
            swiper.forEach(function(swiperEl) {
                handlePressQuoteSlides(swiperEl);
            })
        }
        
        //Move to respective slide on logo click
        $(`.press-quotes-instance-${index} .press-quotes__logos-wrapper .press_quotes__logo`).on('click', function(){
            var slideIndex = $(this).data("slideId");
            swiper.slideTo(slideIndex);
        });
        
        //Highlights the current slide logo
        swiper.on('slideChange', function (e) {          
            $(`.press-quotes-instance-${index} .press-quotes__logos-wrapper .press_quotes__logo`).each( function() {
                $(this).removeClass("press_quotes__logo--active");
                var slideIndex = $(this).data("slideId");
                
                if (slideIndex == swiper.activeIndex) {
                    $(this).addClass("press_quotes__logo--active");
                }
            });
        }); 
    });
});

